import React from "react";
import NextLink from "next/link";
import Link from "@mui/material/Link";
import { useRouter } from "next/router";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";

import Pages from "src/constants/pages";

const titleByName = {
	update: "ویرایش",
	"[id]": "پرداخت ",
	"[facilityId]": " ",
	merchant: "پذیرنده",
	"wallet": "کیف پول",
	facilities: "تسهیلات",
	dashboard: "داشبورد",
	"jet-card": "جت کارت",
	profile: "حساب کاربری",
	requests: "درخواست ها",
	facility: "درخواست وام",
	staticFlow: "درخواست وام",
	validation: "اعتبار سنجی",
	"gift-credit": "اعتبار من",
	"user-panel": "پنل کاربری",
	providers: "انتخاب تسهیلات",
	request: "درخواست پذیرنگی",
	"register-cheque": "ثبت چک",
	"[giftId]": "پرداخت دلخواه",
	wagePayment: "عضویت جت کلاب",
	assignCredit: "اعطای اعتبار",
	signContract: "امضای قرارداد",
	payment: "پرداخت هزینه استعلام",
	staticFlow: "مراحل دریافت وام",
	instalments: "بازپرداخت اقساط",
	rules: "تایید قوانین و مقررات",
	"join-jet-club": "عضویت جت کلاب",
	transactions: "لیست تراکنش ها ",
	tickets: "ثبت درخواست پشتیبانی",
	installments: "بازپرداخت اقساط",
	"sign-contract": "امضای قرارداد",
	uploadChequeImage: "ثبت چک ضمانت",
	"user-info": "ثبت اطلاعات کاربری",
	"loan-payment": "پرداخت اقساط من",
	"jet-club": "دریافت تخفیف جت کلاب",
	"credit-transfer": "انتقال اعتبار",
	"select-facility": "انتخاب تسهیلات",
	"work-flow": "مراحل دریافت تسهیلات",
	postalCodeInquiry: "استعلام کد پستی",
	"bank-inquiries": "استعلام های بانکی",
	authentication: "ورود اطلاعات کاربری",
	"guarantor-info": "ورود اطلاعات ضامن",
	validationReport: "گزارش اعتبار سنجی",
	"static-flow": "مراحل دریافت اعتبار ",
	"pay-inquiry-fee": "پرداخت هزینه استعلام",
	"cheque-handover": "تحویل اصل چک به شعبه",
	education_job_info: "اطلاعات تحصیلی و شغلی",
	verification: "تایید حساب بانک ملت و نظام وظیفه",
	"bank-rating-validation": "اعتبارسنجی رتبه بانکی",
	"register-personal-information": "ورود اطلاعات فردی",
	"register-career-education-info": "ورود اطلاعات تحصیلی و شغلی"
};

const MuiBreadcrumbs = () => {
	const { query, pathname } = useRouter();
	const pathnames = pathname
		.split(Pages.Main)
		.filter(x => x !== "main" && x !== "facility" && x !== "payment" && x !== "[giftId]" && x !== "[facilityId]" && x !== "");

	return (
		<Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1 }}>
			{pathname?.length > 0 ?
				<Typography component={Link} variant="caption" underline="hover" color="inherit" href="/">
					صفحه اصلی
				</Typography>
				: ""}
			{pathnames.map((name, index) => {
				const isLast = index === pathnames.length - 1;
				let routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
				if (name === "dashboard") {
					routeTo = Pages.UserPanel;
				};

				if (query?.facilityId && routeTo.includes("work-flow")) {
					if (isLast) {
						routeTo = `/${pathnames.slice(0, index).join("/")}/${query?.facilityId}/${pathnames[index]}`;
					} else {
						routeTo = `${routeTo}/${query?.facilityId}`;
					};
				};
				return (
					<Typography
						key={name}
						prefetch={false}
						variant="caption"
						underline="hover"
						component={NextLink}
						sx={{ cursor: "pointer" }}
						color={isLast ? "primary" : "inherit"}
						fontWeight={isLast ? "bold" : "normal"}
						href={query?.giftId && index > 0 ? `${routeTo}/${query?.giftId}` : routeTo}
					>
						{titleByName[name] || name}
					</Typography>
				)
			})}
		</Breadcrumbs>
	);
};
export default MuiBreadcrumbs;